import { postRequest } from "./NetworkService";
import { Apinames } from "../utils/Apiname";

// Types for payment request/response
export interface PaymentRequest {
  paymentMethodId: string;
  billId: number;
}

export interface PaymentResponse {
  success: boolean;
  message: string;
  clientSecret?: string;
}

export const processPayment = async (
  paymentData: PaymentRequest
): Promise<any> => {
  try {
    const response = await postRequest(Apinames.payBill, paymentData);
    return response;
  } catch (error) {
    console.error("Payment processing error:", error);

    // If it's already a string error from NetworkService, re-throw it
    if (typeof error === "string") {
      throw error;
    }

    // Handle axios error response
    if (error && typeof error === "object" && "response" in error) {
      const axiosError = error as any;
      if (axiosError.response?.data?.result) {
        throw axiosError.response.data.result;
      }
    }

    throw error;
  }
};
